import { ProcessStep } from '../types';
import { ClipboardList, Search, FileCheck, PiggyBank, BarChart } from 'lucide-react';

export const processSteps: ProcessStep[] = [
  {
    icon: ClipboardList,
    title: 'Analyse initiale',
    description: 'Vous nous contactez pour un diagnostic gratuit de votre situation.'
  },
  {
    icon: Search,
    title: 'Identification des opportunités',
    description: 'Nous évaluons vos projets éligibles aux CEE.'
  },
  {
    icon: FileCheck,
    title: 'Gestion des démarches',
    description: 'Constitution et dépôt des dossiers CEE.'
  },
  {
    icon: PiggyBank,
    title: 'Optimisation des primes',
    description: 'Nous négocions pour maximiser vos subventions.'
  },
  {
    icon: BarChart,
    title: 'Suivi des résultats',
    description: 'Vous profitez des économies réalisées.'
  }
];